import { useMemo } from 'react';

import { useContentfulContentTypeEntry } from '@order/Contentful';

export const useSweetpassCheckoutLoadedContent = () => {
  const { data: contentfulData, fetching: isLoading } =
    useContentfulContentTypeEntry<ContentfulSweetpassCheckoutPage>({
      contentType: 'sweetpassCheckoutPage',
      include: 2,
    });

  const content = useMemo(() => {
    return { termsAndConditions: contentfulData?.fields?.termsAndConditions };
  }, [contentfulData?.fields?.termsAndConditions]);

  return { content, isLoading };
};

// ––– Checkout Page –––––––––––––––––––––––––

export type SweetpassCheckoutPage = {
  readonly termsAndConditions?: string;
};

type ContentfulSweetpassCheckoutPage = {
  readonly termsAndConditions: string;
};
